import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

function ScrollToTop() {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);  // Scroll to top on route change
  }, [location.pathname]);  // Trigger when path changes

  return null;  // This component does not render anything
}

export default ScrollToTop;
